import { render, staticRenderFns } from "./FooterSectionComponent.vue?vue&type=template&id=6156f1a7&scoped=true"
import script from "./FooterSectionComponent.vue?vue&type=script&lang=js"
export * from "./FooterSectionComponent.vue?vue&type=script&lang=js"
import style0 from "./FooterSectionComponent.vue?vue&type=style&index=0&id=6156f1a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6156f1a7",
  null
  
)

export default component.exports